import { get } from "lodash";
import { Autocomplete, Checkbox } from "@mui/material";
import TextField from "./TextField";

export default function AutocompleteMultiSelect({
  label,
  name,
  defaults,
  options,
  formikProps,
  placeholder,
  value = [],
  required = false,
  ...props
}) {
  const formValues =
    value.length > 0 ? value : get(formikProps?.values, name, []);

  const selectedOptions = formValues
    .map((val) => options.find((opt) => opt[defaults.primaryKey] === val))
    .filter(Boolean);

  function handleTouch() {
    formikProps?.setTouched({
      ...formikProps?.touched,
      [name]: true,
    });
  }

  return (
    <Autocomplete
      size="small"
      multiple
      fullWidth
      disableCloseOnSelect
      value={selectedOptions}
      options={options}
      onClick={handleTouch}
      onChange={(e, newValue, reason, details) => {
        const isSelectAllClicked = details?.option?.value === "ALL";

        if (isSelectAllClicked) {
          // Replace input value with all real options
          const allOptions = options.filter((o) => o.value !== "ALL");
          // setSelectedOptions(allOptions);

          const allIds = allOptions.map((opt) => opt[defaults.primaryKey]);
          formikProps.setFieldValue(name, allIds);
        } else {
          // setSelectedOptions(newValue);
          const newIds = newValue
            .filter((opt) => opt.value !== "ALL") // always exclude "ALL"
            .map((opt) => opt[defaults.primaryKey]);
          formikProps.setFieldValue(name, newIds);
        }
      }}
      isOptionEqualToValue={(option, val) =>
        option[defaults.primaryKey] === val[defaults.primaryKey]
      }
      getOptionLabel={(option) =>
        typeof option === "string"
          ? option
          : get(option, defaults.displayLabel, "")
      }
      renderOption={(props, option, { selected }) => (
        <li {...props} style={{ fontSize: "18px" }}>
          <Checkbox checked={selected} />
          {option[defaults.displayLabel]}
        </li>
      )}
      renderValue={(value) =>
        value
          .filter((val) => val.value !== "ALL") // exclude "Select All" from input
          .map((val) => val[defaults.displayLabel])
          .join(", ")
      }
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          name={name}
          label={label}
          fullWidth
          placeholder={formValues.length === 0 ? placeholder : ""}
          $isFilled={formValues.length > 0}
          error={Boolean(
            formikProps?.touched[name] && get(formikProps, `errors.${name}`)
          )}
          helperText={
            formikProps?.touched[name] && get(formikProps, `errors.${name}`)
          }
          onBlur={handleTouch}
          sx={{
            "& .MuiInputBase-input": {
              padding: "8.5px 14px",
              lineHeight: "1.4375em",
            },
          }}
        />
      )}
    />
  );
}
